import { apiFetch } from './client';
import type { Skill } from '../types/contracts';

export interface BuiltinTool {
  id: string;
  label: string;
  description: string;
  aliases?: string[];
  group?: string;
  groupLabel?: string;
  groupDescription?: string;
}

export const skillsApi = {
  list:        ()           => apiFetch<Skill[]>('/api/skills'),
  getForAgent: (id: string) => apiFetch<Skill[]>(`/api/skills/agent/${id}`),
  builtins:    ()           => apiFetch<BuiltinTool[]>('/api/builtins'),
};
